import React from 'react';

const TrustBadges = () => {
  return null;
};

export default TrustBadges;